import * as SwitchPrimitive from '@radix-ui/react-switch';

interface SwitchProps {
  checked?: boolean;
  defaultChecked?: boolean;
  onCheckedChange?: (checked: boolean) => void;
  onText?: string;
  offText?: string;
  disabled?: boolean;
}

export function Switch({
  checked,
  defaultChecked,
  onCheckedChange,
  onText = 'On',
  offText = 'Off',
  disabled = false,
}: SwitchProps) {
  return (
    <div className="flex items-center gap-2">
      <SwitchPrimitive.Root
        checked={checked}
        defaultChecked={defaultChecked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        className="relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-300 transition-colors data-[state=checked]:bg-primary disabled:cursor-not-allowed disabled:opacity-50"
      >
        <SwitchPrimitive.Thumb className="pointer-events-none block h-5 w-5 rounded-full bg-white shadow-sm transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0" />
      </SwitchPrimitive.Root>
      <span className="text-sm text-gray-600 select-none min-w-[24px]">
        {checked !== undefined ? (checked ? onText : offText) : null}
        {checked === undefined && defaultChecked !== undefined ? (defaultChecked ? onText : offText) : null}
      </span>
    </div>
  );
}
